<template>
  <div class="safe-detial">
    <z-tabs
      v-model="active"
      swipeable
      center
      sticky
      @click="tabsChange"
      background="rgb(248, 248, 248)"
    >
      <z-tab title="账号状态" :info="+tabNumObj.accountStatusNum">
        <account-status :active="0" @setTabNum="setTabNum" />
      </z-tab>
      <z-tab title="功能状态" :info="+tabNumObj.functionStatusNum">
        <account-status :active="1" @setTabNum="setTabNum" />
      </z-tab>
      <z-tab title="商品状态" :info="+tabNumObj.productStatusNum">
        <account-status :active="2" @setTabNum="setTabNum" />
      </z-tab>
      <z-tab title="钱款状态" :info="+tabNumObj.moneyStatusNum">
        <account-status :active="3" @setTabNum="setTabNum" />
      </z-tab>
    </z-tabs>
  </div>
</template>
<script>
import native from '@zz-common/native-adapter'
//import setPicSize from '@zz-app/setPicSize'
import { Tab, Tabs } from '@zz-common/zz-ui'
import { queryParams } from '../../../lib/utils'
import AccountStatus from './account-status/index'

const query = queryParams()
export default {
  name: 'uploadExample',
  data() {
    return {
      active: query.active || this.$route.query.active || 0, //1 平台规则 2 安全知识,
      tabNumObj: {}
    }
  },
  computed: {},
  components: {
    zTabs: Tabs,
    zTab: Tab,
    AccountStatus
  },
  methods: {
    setTabNum(tabNumObj) {
      this.tabNumObj = tabNumObj
    },
    tabsChange(index, title) {
      console.log('index', index)
      console.log('title', title)
    }
  },
  mounted() {
    native.setTitle({
      title: '安全检测'
    })
  },
  beforeRouteEnter(to, from, next) {
    console.log('Detial to', to)
    console.log('Detial from', from)
    next((vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
